var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 9"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#9797A6",
  strokeWidth: 1.5,
  d: "m13.05 1.55-6 6-6-6"
})));
export { SvgChevDown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDE0IDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xMy4wNTA4IDEuNTUwNzhMNy4wNTA3OSA3LjU1MDc3TDEuMDUwNzggMS41NTA3NiIgc3Ryb2tlPSIjOTc5N0E2IiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8L3N2Zz4K";